import React from 'react'
import PropTypes from 'prop-types'
import InfoTooltip from '../InfoTooltip'
import { STATUS, STATUS_BG_CLASS, STATUS_TEXT_CLASS } from './status'

const CONTAINER_CLASSES = 'tw:flex tw:items-center tw:gap-4 tw:p-4 tw:bg-white tw:flex-1 tw:min-w-0'

const ICON_BOX_CLASSES = 'tw:flex tw:items-center tw:justify-center '
  + 'tw:w-12 tw:h-12 tw:rounded-[8px] tw:text-2xl tw:shrink-0'

const SUFFIX_CLASSES = 'tw:text-base tw:font-medium tw:text-gray-500'

const renderSuffix = suffix =>
  suffix ? <span className={SUFFIX_CLASSES}>{suffix}</span> : null

const KpiCard = ({ icon, label, value, suffix, badge, tooltip, status }) => (
  <div className={CONTAINER_CLASSES}>
    <div className={`${ICON_BOX_CLASSES} ${STATUS_BG_CLASS[status]} ${STATUS_TEXT_CLASS[status]}`}>
      {icon}
    </div>
    <div className="tw:flex tw:flex-col tw:min-w-0">
      <div className="tw:flex tw:items-center tw:gap-1 tw:text-sm tw:text-gray-500">
        <span>{label}</span>
        {tooltip ? <InfoTooltip content={tooltip} /> : null}
      </div>
      <div className="tw:flex tw:items-baseline tw:gap-2">
        <div className="tw:flex tw:items-baseline tw:gap-1">
          <span className="tw:text-xl tw:font-bold tw:text-gray-900">{value}</span>
          {renderSuffix(suffix)}
        </div>
        {badge}
      </div>
    </div>
  </div>
)

KpiCard.propTypes = {
  badge: PropTypes.node,
  icon: PropTypes.node.isRequired,
  label: PropTypes.string.isRequired,
  status: PropTypes.oneOf(Object.values(STATUS)),
  suffix: PropTypes.string,
  tooltip: PropTypes.string,
  value: PropTypes.node.isRequired
}

KpiCard.defaultProps = {
  badge: null,
  status: STATUS.NEUTRAL,
  suffix: null,
  tooltip: null
}

export default KpiCard
